import { SECTOR_TAGS } from "@/lib/clients";

export const SectorsStrip = () => (
  <section className="bg-[#FACC15] text-black py-5 overflow-hidden" aria-label="Settori seguiti" data-testid="sectors-strip">
    <div className="marquee-mask">
      <div className="marquee-track items-center" data-testid="sectors-strip-track">
        {[...SECTOR_TAGS, ...SECTOR_TAGS].map((t, i) => (
          <span key={`${t}-${i}`} className="flex items-center whitespace-nowrap" data-testid="sectors-strip-item">
            <span
              className="text-lg sm:text-xl font-bold uppercase tracking-[0.12em]"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              {t}
            </span>
            <span className="mx-6 sm:mx-8 w-2 h-2 rounded-full bg-black/70 inline-block" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  </section>
);

export default SectorsStrip;
